import React, { memo } from 'react';
import { Pagination as MuiPagination, PaginationItem, Box } from '@mui/material';

import { useStyles } from './styles';

export interface IPaginationProps {
  count: number;
  page: number;
  onChange: (event: React.ChangeEvent<unknown>, value: number) => void;
  color?: 'primary' | 'secondary' | 'standard';
  size?: 'small' | 'medium' | 'large';
  shape?: 'circular' | 'rounded';
  showFirstButton?: boolean;
  showLastButton?: boolean;
  siblingCount?: number;
  boundaryCount?: number;
  disabled?: boolean;
  hideOnSinglePage?: boolean;
  styleClass?: string;
  /** Base id for automation. The container uses `${testId}`, each page button
   * `${testId}-page-{n}` and the arrows `${testId}-previous` / `${testId}-next`. */
  testId?: string;
}

const Pagination = ({
  count,
  page,
  onChange,
  color = 'primary',
  size = 'medium',
  shape = 'rounded',
  showFirstButton = false,
  showLastButton = false,
  siblingCount = 1,
  boundaryCount = 3,
  disabled = false,
  hideOnSinglePage = true,
  styleClass,
  testId,
}: IPaginationProps) => {
  const classes = useStyles();

  if (hideOnSinglePage && count <= 1) {
    return null;
  }

  return (
    <Box className={`${classes.paginationContainer} ${styleClass || ''}`} data-testid={testId}>
      <MuiPagination
        count={count}
        page={page}
        onChange={onChange}
        color={color}
        size={size}
        shape={shape}
        showFirstButton={showFirstButton}
        showLastButton={showLastButton}
        siblingCount={siblingCount}
        boundaryCount={boundaryCount}
        disabled={disabled}
        className={classes.pagination}
        renderItem={item => {
          const itemKey = item.type === 'page' ? `page-${item.page}` : item.type;
          return <PaginationItem {...item} data-testid={testId ? `${testId}-${itemKey}` : undefined} />;
        }}
      />
    </Box>
  );
};

export default memo(Pagination);
